<script>
import sprite from '@/mixins/sprite.js'

export default {
  mixins: [
    sprite
  ]
}
</script>
